import React, { type ComponentProps } from 'react';

import { LoadablePaint } from '@confluence/loadable';

const PlatformNavigationLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PlatformNavigation" */ './PlatformNavigationComponent.tsx'
			)
		).PlatformNavigationComponent,
});

export const PlatformNavigation = (props: PlatformNavigationProps) => (
	<PlatformNavigationLoader {...props} />
);

type PlatformNavigationProps = ComponentProps<typeof PlatformNavigationLoader>;
